module.exports = __webpack_public_path__ + "img/zk1.5ba0c8c6.jpg";